import { render, staticRenderFns } from "./HorizontalMenu.vue?vue&type=template&id=63684db1&scoped=true"
import script from "./HorizontalMenu.vue?vue&type=script&lang=js"
export * from "./HorizontalMenu.vue?vue&type=script&lang=js"
import style0 from "./HorizontalMenu.vue?vue&type=style&index=0&id=63684db1&prod&lang=css"
import style1 from "./HorizontalMenu.vue?vue&type=style&index=1&id=63684db1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63684db1",
  null
  
)

export default component.exports